var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-responsive",
    { staticClass: "w-100 d-flex", attrs: { "aspect-ratio": 1 } },
    [
      _c(
        "v-card",
        {
          staticClass:
            "border pt-2 pb-3 px-3 d-flex flex-column fill-height w-100 kpi-card",
          attrs: {
            outlined: "",
            elevation: _vm.$vuetify.theme.dark ? 2 : 2,
            color: _vm.$vuetify.theme.dark ? "#424242" : "#FFFFFF",
          },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "flex-grow-0",
              attrs: { "no-gutters": "", align: "center" },
            },
            [
              _vm.icon
                ? _c("v-icon", { staticClass: "mr-2", attrs: { size: "22" } }, [
                    _vm._v(" " + _vm._s(_vm.icon) + " "),
                  ])
                : _vm._e(),
              _c(
                "span",
                { staticClass: "text-subtitle-1 font-weight-medium" },
                [_vm._v(" " + _vm._s(_vm.kpiTitle) + " ")]
              ),
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "flex-grow-1",
              attrs: { "no-gutters": "", align: "center", justify: "center" },
            },
            [
              _c(
                "v-col",
                { staticClass: "pa-0 text-center", attrs: { cols: "12" } },
                [
                  _vm.kpiValue !== null &&
                  _vm.kpiValue !== undefined &&
                  _vm.kpiValue !== ""
                    ? _c("span", { staticClass: "text-h3 font-weight-bold" }, [
                        _vm._v(" " + _vm._s(_vm.formattedValue) + " "),
                      ])
                    : _c("span", { staticClass: "text-h3 font-weight-bold" }, [
                        _vm._v("-"),
                      ]),
                  _vm.kpiUnit === "%"
                    ? _c(
                        "span",
                        { staticClass: "ml-1 text-h4 font-weight-bold" },
                        [_vm._v("%")]
                      )
                    : _vm.kpiUnit
                    ? _c("span", { staticClass: "ml-1 text-subtitle-1" }, [
                        _vm._v(_vm._s(_vm.kpiUnit)),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }